module.exports = __webpack_public_path__ + "media/audio24.8f5691f4.mp3";